import { type TypedDocumentNode, gql } from '@apollo/client';
import { FormattedNumber } from 'react-intl';
import { CSSProperties } from 'styled-components';

import { Box } from '@sorare/core/src/atoms/icons/Box';
import { LabelS } from '@sorare/core/src/atoms/typography';

import {
  Chip,
  DEFAULT_COLOR,
  ImageContainer,
} from 'components/rewards/AnyRewardConfig';

import type { RewardMultiplier_lineup } from './__generated__/index.graphql';

type Props = {
  lineup: RewardMultiplier_lineup;
};

export const RewardMultiplier = ({ lineup }: Props) => {
  const boost = lineup.rewardMultiplier - 1;
  if (boost <= 0) {
    return null;
  }

  const content = (
    <LabelS as="p" bold className="text-center">
      <FormattedNumber
        value={lineup.rewardMultiplier - 1}
        style="percent"
        maximumFractionDigits={2}
        signDisplay="always"
      />
    </LabelS>
  );

  return (
    <Chip style={{ '--color': DEFAULT_COLOR } as CSSProperties}>
      <ImageContainer>
        <Box gradient="green" />
      </ImageContainer>
      {content}
    </Chip>
  );
};

RewardMultiplier.fragments = {
  lineup: gql`
    fragment RewardMultiplier_lineup on So5Lineup {
      id
      rewardMultiplier
    }
  ` as TypedDocumentNode<RewardMultiplier_lineup>,
};
